import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/http'
import moment from 'moment'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    pages: [],
    home: {},
    galleryLocations: [],
    teamLocations: [],
    homePageCards: [],
    homeGalleryItems: [],
    gallery: {
      maxPages: 0,
      pages: {}
    },
    news: {
      maxPages: 0,
      pages: {}
    },
    newsItems: [],
    updates: {
      maxPages: 0,
      pages: {}
    },
    updatesItems: [],
    categories: [],
    usefulResources: {
      maxPages: 0,
      pages: {}
    },
    usefulResourcesItems: [],
    emotionalSupport: {
      maxPages: 0,
      pages: {}
    },
    emotionalSupportItems: [],
    homeUsefulResources: [],
    events: [],
    teamMembers: []
  },
  strict: debug,
  getters: {
    getPage: (state) => (slug) => {
      return state.pages.find(page => page.slug === slug)
    },
    getGalleryPage: (state) => (page) => {
      return state.gallery.pages[page] ? state.gallery.pages[page] : [];
    },
    getGalleryMaxPages(state) {
      return state.gallery.maxPages;
    },
    getNewsPage: (state) => (page) => {
      return state.news.pages[page] ? state.news.pages[page] : [];
    },
    getNewsMaxPages(state) {
      return state.news.maxPages;
    },
    getNewsItem: (state) => (slug) => {
      return state.newsItems.find(item => item.slug === slug)
    },
    getUpdatesPage: (state) => (page) => {
      return state.updates.pages[page] ? state.updates.pages[page] : [];
    },
    getUpdatesMaxPages(state) {
      return state.updates.maxPages;
    },
    getUpdatesItem: (state) => (slug) => {
      return state.updatesItems.find(item => item.slug === slug)
    },
    getUsefulResourcesPage: (state) => (page) => {
      return state.usefulResources.pages[page] ? state.usefulResources.pages[page] : [];
    },
    getUsefulResourcesMaxPages(state) {
      return state.usefulResources.maxPages;
    },
    getUsefulResourcesItem: (state) => (slug) => {
      return state.usefulResourcesItems.find(item => item.slug === slug)
    },
    getEmotionalSupportPage: (state) => (page) => {
      return state.emotionalSupport.pages[page] ? state.emotionalSupport.pages[page] : [];
    },
    getEmotionalSupportMaxPages(state) {
      return state.emotionalSupport.maxPages;
    },
    getEmotionalSupportItem: (state) => (slug) => {
      return state.emotionalSupportItems.find(item => item.slug === slug)
    },
    getEvents(state) {
      var today = moment.utc();
      return state.events.filter(event => {
        let date = moment.utc(event.when);
        return date.isSameOrAfter(today);
      });
    },
    getExpiredEvents(state) {
      var today = moment.utc();
      return state.events.filter(event => {
        let date = moment.utc(event.when);
        return date.isBefore(today);
      });
    },
    getEvent: (state) => (slug) => {
      return state.events.find(event => event.slug === slug)
    },
    getTeamMembers: (state) => (location) => {
      if (location == 'all') {
        return state.teamMembers;
      } else {
        return state.teamMembers.filter(teamMember => teamMember.location.slug === location)
      }
    },
  },
  mutations: {
    setPage(state, page) {
      state.pages.push(page);
    },
    setHome(state, home) {
      Vue.set(state, 'home', home);
    },
    setGalleryLocations(state, locations) {
      Vue.set(state, 'galleryLocations', locations);
    },
    setTeamLocations(state, locations) {
      Vue.set(state, 'teamLocations', locations);
    },
    setGalleryPage(state, {items, page, maxPages}) {
      state.gallery.maxPages = maxPages;
      Vue.set(state.gallery.pages, page, items);
    },
    clearGalleryPages(state) {
      Vue.set(state.gallery, 'pages', {});
    },
    setHomeGalleryItems(state, {items}) {
      Vue.set(state, 'homeGalleryItems', items);
    },
    setNewsPage(state, {items, page, maxPages}) {
      state.news.maxPages = maxPages;
      Vue.set(state.news.pages, page, items);
      state.newsItems = state.newsItems.concat(items);
    },
    setNewsItem(state, {item}) {
      state.newsItems.push(item);
    },
    setUpdatesPage(state, {items, page, maxPages}) {
      state.updates.maxPages = maxPages;
      Vue.set(state.updates.pages, page, items);
      state.updatesItems = state.updatesItems.concat(items);
    },
    setUpdatesItem(state, {item}) {
      state.updatesItems.push(item);
    },
    setCategories(state, categories) {
      Vue.set(state, 'categories', categories);
    },
    setUsefulResourcesPage(state, {items, page, maxPages}) {
      state.usefulResources.maxPages = maxPages;
      Vue.set(state.usefulResources.pages, page, items);
      state.usefulResourcesItems = state.usefulResourcesItems.concat(items);
    },
    clearUsefulResourcesPages(state) {
      Vue.set(state.usefulResources, 'pages', {});
    },
    setUsefulResourcesItem(state, {item}) {
      state.usefulResourcesItems.push(item);
    },
    setEmotionalSupportPage(state, {items, page, maxPages}) {
      state.emotionalSupport.maxPages = maxPages;
      Vue.set(state.emotionalSupport.pages, page, items);
      state.emotionalSupportItems = state.emotionalSupportItems.concat(items);
    },
    clearEmotionalSupportPages(state) {
      Vue.set(state.emotionalSupport, 'pages', {});
    },
    setEmotionalSupportItem(state, {item}) {
      state.emotionalSupportItems.push(item);
    },
    setHomeUsefulResources(state, {items}) {
      Vue.set(state, 'homeUsefulResources', items);
    },
    setEvents(state, {events}) {
      Vue.set(state, 'events', events);
    },
    setTeamMembers(state, {items}) {
      Vue.set(state, 'teamMembers', items);
    },
    setHomePageCards(state, items) {
      items.sort(function(itemA, itemB) {
        return parseInt(itemA.card.order) - parseInt(itemB.card.order);
      });
      Vue.set(state, 'homePageCards', items);
    },
  },
  actions: {
    fetchPage({state, getters, commit}, args) {
      let slug = args;
      /* eslint-disable no-unused-vars */
      let template = false;
      /* eslint-enable no-unused-vars */
      if (typeof args == 'object') {
        slug = args.slug;
        template = args.template;
      }
      if (getters.getPage(slug)) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('page/' + slug + '?home=' + state.home.slug  + (template ? '&template=' + template: '') )
          .then((data) => {
            commit('setPage', data);
          });
      }
    },
    fetchHome({state, commit}, slug) {
      if (state.home && state.home.slug == slug) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('home/' + slug )
          .then((data) => {
            commit('setHome', data);
          });
      }
    },
    fetchGalleryLocations({state, commit}, home) {
      if (state.galleryLocations.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('locations/' + home + '/gallery-item' )
          .then((data) => {
            commit('setGalleryLocations', data);
          });
      }
    },
    fetchTeamLocations({state, commit}, home) {
      if (state.teamLocations.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('locations/' + home + '/team-member' )
          .then((data) => {
            commit('setTeamLocations', data);
          });
      }
    },
    fetchGalleryPage({getters, commit}, {home, page, location}) {
      if (getters.getGalleryPage(page).length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('gallery/' + home + (location ? '/' + location : '') + '?page=' + page )
          .then(({items, maxPages}) => {
            commit('setGalleryPage', {page, items, maxPages});
          });
      }
    },
    fetchHomeGallery({state, commit}, {home}) {
      if (state.homeGalleryItems.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('gallery/' + home + '/all?per-page=4' )
          .then(({items}) => {
            commit('setHomeGalleryItems', {items});
          });
      }
    },
    fetchNewsPage({getters, commit}, {home, page}) {
      if (getters.getNewsPage(page).length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('news/' + home + '?page=' + page )
          .then(({items, maxPages}) => {
            commit('setNewsPage', {page, items, maxPages});
          });
      }
    },
    fetchNewsItem({getters, commit}, {home, slug}) {
      if (getters.getNewsItem(slug)) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('news/' + home + '/' + slug )
          .then((item) => {
            commit('setNewsItem', {item});
          });
      }
    },
    fetchUpdatesPage({getters, commit}, {home, page}) {
      if (getters.getUpdatesPage(page).length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('updates/' + home + '?page=' + page )
          .then(({items, maxPages}) => {
            commit('setUpdatesPage', {page, items, maxPages});
          });
      }
    },
    fetchUpdatesItem({getters, commit}, {home, slug}) {
      if (getters.getUpdatesItem(slug)) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('updates/' + home + '/' + slug )
          .then((item) => {
            commit('setUpdatesItem', {item});
          });
      }
    },
    fetchCategories({state, commit}) {
      if (state.categories.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('categories')
          .then((data) => {
            commit('setCategories', data);
          });
      }
    },
    fetchUsefulResourcesPage({getters, commit}, {home, page, category}) {
      if (getters.getUsefulResourcesPage(page).length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('useful-resources/' + home + (category ? '/' + category : 'all') + '?page=' + page )
          .then(({items, maxPages}) => {
            commit('setUsefulResourcesPage', {page, items, maxPages});
          });
      }
    },
    fetchUsefulResourcesItem({getters, commit}, {home, slug}) {
      if (getters.getUsefulResourcesItem(slug)) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('useful-resource/' + home + '/' + slug )
          .then((item) => {
            commit('setUsefulResourcesItem', {item});
          });
      }
    },
    fetchEmotionalSupportPage({getters, commit}, {home, page}) {
      if (getters.getEmotionalSupportPage(page).length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('emotional-support-items/' + home + '?page=' + page )
          .then(({items, maxPages}) => {
            commit('setEmotionalSupportPage', {page, items, maxPages});
          });
      }
    },
    fetchEmotionalSupportItem({getters, commit}, {home, slug}) {
      if (getters.getEmotionalSupportItem(slug)) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('emotional-support/' + home + '/' + slug )
          .then((item) => {
            commit('setEmotionalSupportItem', {item});
          });
      }
    },
    fetchHomeUsefulResources({state, commit}, {home}) {
      if (state.homeUsefulResources.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('useful-resources/' + home + '/all?per-page=1&pinned=true')
          .then(({items}) => {
            commit('setHomeUsefulResources', {items});
          });
      }
    },
    fetchEvents({state, commit}, home) {
      if (state.events.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('events/' + home )
          .then(({events}) => {
            commit('setEvents', {events});
          });
      }
    },
    fetchTeamMembers({state, commit}, home) {
      if (state.teamMembers.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('team-members/' + home )
          .then(({items}) => {
            commit('setTeamMembers', {items});
          });
      }
    },
    fetchHomePageCards({state, commit}) {
      if (state.homePageCards.length) {
        return new Promise((resolve) => {
          resolve();
        })
      } else {
        return http.authGet('pages/home-cards/?home=' + state.home.slug )
          .then((items) => {
            commit('setHomePageCards', items);
          });
      }
    },
  }
})
